export default "__VITE_ASSET__BvxK6aLn__"